module.exports = "/assets/dist/images/bodystyles_hatchbacks.png?87dac2f3610ac5d7ff2dd1fc123ed641";